import { render, staticRenderFns } from "./Seal.vue?vue&type=template&id=63be6ae6&scoped=true"
import script from "./Seal.vue?vue&type=script&lang=js"
export * from "./Seal.vue?vue&type=script&lang=js"
import style0 from "./Seal.vue?vue&type=style&index=0&id=63be6ae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be6ae6",
  null
  
)

export default component.exports